import * as React from "react";
const SvgCrown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M0 16.215V2.804C0 .941 1.078.493 2.394 1.81L6.02 5.436a1.394 1.394 0 0 0 1.974 0L13.006.41a1.394 1.394 0 0 1 1.974 0l5.026 5.026a1.394 1.394 0 0 0 1.974 0l3.626-3.626C26.922.493 28 .941 28 2.803V16.23c0 4.2-2.8 7-7 7H7c-3.864-.015-7-3.15-7-7.015"
    />
  </svg>
);
export default SvgCrown;
